import { Router } from "@angular/router";

export class NavigationHelper {
    public static async loadComponent(url: any, router: Router): Promise<boolean> {
        await router.navigateByUrl('.', { skipLocationChange: false });
        return router.navigateByUrl(url);
    }

}